//import { isExpressionFactoryMetadata } from '@angular/compiler/src/render3/r3_factory';
import { Component, OnInit, } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { CatalogoService } from '../../../services/catalogo/catalogo.service';
import { InventarioService } from '../../../services/inventario/inventario.service';
import { ProveedorService } from '../../../services/proveedor/proveedor.service';

@Component({
  selector: 'app-movimientos',
  templateUrl: './movimientos.component.html',
  styleUrls: ['./movimientos.component.scss'],
  standalone: false,
  providers: [MessageService]
})
export class MovimientosComponent implements OnInit {
  loadMenu: boolean = true;
  load: boolean = false;
  lsTipoMovimiento: Array<any> = [];
  lsTipoMovimientoTienda: Array<any> = [{ id: 1, label: "Venta" }, { id: 5, label: "Ingreso de mercancia" },
  { id: 6, label: "Traslado de mercancia" }, { id: 10, label: "Salida de mercancia" }];
  lsMovimientos: Array<any> = [];
  tipoMovimientoSelected: number = 0;
  selectedSKU: any = {};
  resultsSKU: Array<any> = [];
  listProducts: Array<any> = [];
  listProductsStore: Array<any> = [];
  lsTiendas: Array<any> = [];
  tiendaSelected: number = 0;
  fieldSearch: any;
  infoEmpresa: any;
  infoMovimientos: Array<any> = [];
  token: any = {};
  infoUser: any = {};
  infoParametrizacion: any = {};
  frmRegistro: FormGroup;
  dateQuery: Date = new Date();
  btnShow: boolean = true;
  conceptoIng: string = "";
  msgMovimiento: Array<any> = [];
  arrayProducts: Array<any> = [{
    codigoProducto: '',
    cantidad: null,
    descripcion: '',
    idTiendaProducto: 0
  }];
  arrayProductsPrint: Array<any> = [];
  totalMovimiento: number = 0;
  totalCantidades: number = 0;
  showConsulta: boolean = false;


  constructor(private message: MessageService,
    private catalogo: CatalogoService,
    private inventario: InventarioService,
    private proveedor: ProveedorService) {
    //carga de formularios
    this.frmRegistro = new FormGroup({
      selectedTipoMov: new FormControl('', [Validators.required]),
      concepto: new FormControl('', [Validators.required, Validators.maxLength(150), Validators.minLength(10)]),
      referencia: new FormControl('', [Validators.maxLength(100), Validators.required]),
      cantidad: new FormControl(null, [Validators.required])
    });

  }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoEmpresa = JSON.parse(localStorage.getItem('empresa') ?? "[]") as Object;
    this.listProducts = JSON.parse(localStorage.getItem("listProducts") ?? "[]") as Array<any>;
    this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");
    this.infoParametrizacion = JSON.parse(localStorage.getItem('parametros') ?? "");
    //pantala de consulta de movimiento
    this.showConsulta = !this.infoParametrizacion.cajeroAdmInventario;

    // obtener todas las posibles tiendas excepto la actual
    this.proveedor.getTiendas(this.token.token, this.infoEmpresa[0].idProveedorNavigation.idProveedor).subscribe((response:any) => {
      this.lsTiendas = response.map((item: any) => {
        return { id: item.idTienda, label: item.nombreTienda }
      }).filter((data: any) => { return data.id != this.infoEmpresa[0].tiendaEmpleados[0].idTienda })
    })

    //obtener tipos de movimientos
    this.inventario.getTipoMovimiento(this.token.token).subscribe((response) => {
      this.lsTipoMovimiento = (response as Array<any>).map((row: any) => {
        return { id: row.idMovimientoTipo, name: row.nombreMovimientoTipo + " (" + row.operacion + ")" }
      });
      this.getRastreo();
    })

  }

  addProducts = (index: number, add?: boolean) => {
    let item = this.listProducts.filter(item => {
      return item.codBarras.toLowerCase() == this.arrayProducts[index].codigoProducto.toLowerCase() || item.referencia.toLowerCase() == this.arrayProducts[index].codigoProducto.toLowerCase()
    });

    if (item.length == 1) {
      // validar que el producto no este registrado
      let row = this.arrayProducts.findIndex((data: any) => {
        return data.codigoProducto.toLowerCase() == this.arrayProducts[index].codigoProducto.toLowerCase()
      });
      if (row != index) {
        this.arrayProducts[index].error = "<div class='p-1 p-message p-message-warn'>El código relacionado ya existe en el listado</div>"
        return
      }

      this.arrayProducts[index].descripcion = "<div class='p-1 p-message p-message-success'>" + item[0].descripcionCorta + "</div>";
      this.arrayProducts[index].text = item[0].descripcionCorta
      this.arrayProducts[index].error = '';
      this.arrayProducts[index].idTiendaProducto = item[0].tiendaProductos[0].idTiendaProducto;
      this.arrayProducts[index].precioProducto = item[0].precioProducto.precioPromocion;
      this.arrayProducts[index].observacion = this.conceptoIng;
      if (add ?? true)
        this.arrayProducts.push({
          codigoProducto: '',
          cantidad: null,
          descripcion: '',
          idTiendaProducto: 0
        });
    }
    else {
      this.arrayProducts[index].error = "<div class='p-1 p-message p-message-warn'>No hay coincidencias con el código del producto</div>"
    }


  }

  deleteProduct = (index: number) => {
    if (this.arrayProducts.length > 1)
      this.arrayProducts.splice(index, 1)
  }

  procesar = () => {
    this.arrayProductsPrint = [];
    if (this.conceptoIng != "") {
      let validacion = this.arrayProducts.filter((row: any) => {
        return row.error != '' || row.cantidad <= 0 || row.descripcion == ''
      });
      if (validacion.length > 0)
        this.message.add({ severity: 'error', summary: 'Error', detail: 'Hay campos que faltan completar, favor valide la información' });
      else {
        if (((this.tipoMovimientoSelected == 6) && (this.tiendaSelected > 0)) || (this.tipoMovimientoSelected != 6)) {
          this.load = true;
          // obtener totales
          this.totalMovimiento = this.arrayProducts.map(row => { return row.cantidad * row.precioProducto }).reduce((a, b) => { return a + b }, 0);
          this.totalCantidades = this.arrayProducts.map(row => { return row.cantidad }).reduce((a, b) => { return a + b }, 0);
          // informaciòn de registro de movimientos a realizar
          let lsArray = this.arrayProducts.map((row: any) => {
            console.log(row.detalleRastreoIdMovimientoTiendaOrigNavigation);
            return {
              idMovimientoTipo: this.tipoMovimientoSelected,
              idTiendaProducto: row.idTiendaProducto,
              descripcion: this.conceptoIng.toUpperCase(),
              referencia: "",
              valor: row.cantidad,
              idEmpleadoProveedor: this.infoUser.empleadoProveedors[0].idEmpleadoProveedor,
              isCantidad: true,
              // propiedad que debe ir de manera obligatoria
              detalleRastreoIdMovimientoTiendaOrigNavigations: !row.detalleRastreoIdMovimientoTiendaOrigNavigation ? null : JSON.parse("[" + JSON.stringify(row.detalleRastreoIdMovimientoTiendaOrigNavigation) + "]")
            }
          });
          this.inventario.setRegistroMovimiento(this.token.token, lsArray, this.infoEmpresa[0].tiendaEmpleados[0].idTienda, false, this.tiendaSelected).subscribe((response) => {
            this.message.add({ severity: 'success', summary: 'Confirmación', detail: response.toString() });
            this.btnShow = false;
            this.load = false;
            this.arrayProductsPrint = this.arrayProducts;
            this.getRastreo();
          })
        } else
          this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor seleccione la tienda' });
      }
    } else
      this.message.add({ severity: 'error', summary: 'Error', detail: 'Relacione el concepto' });
  }


  reload = () => {
    window.location.reload();
  }

  getInfoMovimientos = () => {
    const dateConvert = this.dateQuery.getFullYear() + '-' + (this.dateQuery.getMonth() + 1) + "-" + this.dateQuery.getDate();

    if (this.tipoMovimientoSelected > 0) {
      //this.load = true;
      this.inventario.getMovimientos(this.token.token, this.infoEmpresa[0].tiendaEmpleados[0].idTienda, dateConvert, this.tipoMovimientoSelected).subscribe((response) => {
        //this.load = false;

        this.lsMovimientos = (response as Array<any>).map((row) => {
          return {
            idRegistro: row.idMovimientoTienda,
            idTiendaProducto: row.idTiendaProductoNavigation.idTiendaProducto,
            fechaRegistro: row.fechaRegistro,
            codBarras: row.idTiendaProductoNavigation.idProductoNavigation.codBarras,
            descripcion: row.idTiendaProductoNavigation.idProductoNavigation.descripcionCorta,
            unidadPresentacion: row.idTiendaProductoNavigation.idProductoNavigation.unidadPresentacion,
            cantidad: row.valor,
            valorInventario: row.valor * this.listProducts.filter((item) => { return item.idProducto == row.idTiendaProductoNavigation.idProducto })[0].precioProducto.precioPromocion,
            inventarioDisponible: row.idTiendaProductoNavigation.cantidadEnMano + row.idTiendaProductoNavigation.cantidadMasiva,
            observacion: row.descripcion
          }
        });

        this.totalCantidades = this.lsMovimientos.map(row => { return row.cantidad }).reduce((a, b) => { return a + b }, 0);
        this.totalMovimiento = this.lsMovimientos.map(row => { return row.valorInventario }).reduce((a, b) => { return a + b }, 0);
        if (this.lsMovimientos.length == 0)
          this.message.add({ severity: 'warn', summary: 'Información', detail: 'No se presentan movimientos para este producto' });
      })
    }
    else {
      this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor seleccione el tipo de movimiento a consultar' });
    }




  }


  printDiv(elem: string, title: string, index?: number) {
    // si viene algo hay auqe armar la impresion
    if (!!index) {
      title = this.tipoMovimientoSelected == 5 ? "Ingreso de mercancia" : 'Salida de mercancia';
      this.arrayProductsPrint = this.lsMovimientos.map((row: any) => {
        return {
          text: row.descripcion,
          error: '',
          idTiendaProducto: row.idTiendaProducto,
          precioProducto: row.valorInventario / row.cantidad,
          cantidad: row.cantidad,
          observacion: row.observacion
        }
      });
    }

    setTimeout(() => {
      const dateConvert = this.dateQuery.getFullYear() + '-' + (this.dateQuery.getMonth() + 1) + "-" + this.dateQuery.getDate();

      let mywindow: any = window.open('', 'PRINT', 'height=400,width=800');

      mywindow.document.write('<html><head><title>' + document.title + '</title>');
      mywindow.document.write('<style>.grid {display: flex; margin-right: -.5rem; margin-left: -.5rem;margin-top: -.5rem;} .col-6{ flex: 0 0 auto; padding: .5rem; width:50%} .hidden{display:none;} </style>');
      mywindow.document.write('</head><body style="font-family: \'Segoe UI\' !important; font-size: 22px !important;" >');
      mywindow.document.write('<h5>' + title.toUpperCase() + ' CORRESPONDIENTE AL DÍA ' + dateConvert + '</h5><div style="text-align:center; width:302px">');
      mywindow.document.write(document.getElementById(elem)!.innerHTML);
      mywindow.document.write('</div></body></html>');

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      mywindow.close();
    }, (!!index) ? 3000 : 0);
    return true;
  }

  getRastreo = () => {
    // revisar si alguna tienda a enviado algo
    this.msgMovimiento = [];
    this.inventario.getRastreoMovimiento(this.token.token, this.infoEmpresa[0].tiendaEmpleados[0].idTienda).subscribe((response) => {
      (response as Array<any>).map((row: any, index: number) => {
        this.msgMovimiento.push({
          type: 'warn',
          text: 'Información enviada por la tienda: <b>' + row.idTiendaOrigenNavigation.nombreTienda
            + '</b>',
          concepto: "Recepcion de mercancia de la " + row.idTiendaOrigenNavigation.nombreTienda,
          index: index,
          detalleRastreoIdMovimientoTiendaDestinoNavigation: {
            idDetalleRastreo: row.detalleRastreos
          }
        })
      });
    })
  }

  cargarInfo = (index: number) => {
    this.conceptoIng = this.msgMovimiento[index].concepto;
    this.arrayProducts = this.msgMovimiento[index].detalleRastreoIdMovimientoTiendaDestinoNavigation.idDetalleRastreo.map((row: any) => {
      return {
        codigoProducto: this.listProducts.filter((item: any) => { return item.idProducto == row.idMovimientoTiendaOrigNavigation.idTiendaProductoNavigation.idProducto })[0].codBarras,
        detalleRastreoIdMovimientoTiendaOrigNavigation: { idRastreo: row.idRastreo, idDetalleRastreo: row.idDetalleRastreo, idMovimientoTiendaOrig: row.idMovimientoTiendaOrig }
      }
    });

    this.arrayProducts.forEach((row: any, index: number) => {
      this.addProducts(index, false);
    });

    this.navegar('listProducts', false);
  }

  navegar = (enlace: string, mobile: boolean) => {
    const el: any = document.getElementById(enlace);
    window.scrollTo(0, el.offsetTop + (mobile ? el.offsetParent.offsetTop : 0));
  }
}
